export default [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/common/newLogin.vue'),
        meta: {}
    },
    {
        path: '/order/detail',
        name: 'OrderDetail',
        component: () => import('@/views/admin/order/detail.vue'),
        meta: {}
    },
    {
        path: '/noAuth',
        name: 'NoAuth',
        component: () => import('@/views/common/noAuth.vue'),
        meta: {}
    },
    {
        // 微信扫码登录落地页（微信内打开，网页授权域名 = 商家端访问域名；非 /admin → 天然免登录）
        path: '/sl/:scene',
        name: 'ScanLanding',
        component: () => import('@/views/common/scanLanding.vue'),
        meta: {}
    },
    {
        // 微信网页授权回调页（微信回跳 ?code=&state=；非 /admin → 天然免登录）
        path: '/wxCallback',
        name: 'ScanCallback',
        component: () => import('@/views/common/scanCallback.vue'),
        meta: {}
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NoFund',
        component: () => import('@/views/common/404.vue'),
        meta: {}
    }
];
